import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import {
  Button,
  Input,
  Table,
  Dropdown,
  Space,
  Popconfirm,
  message,
} from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
import Create from './Create'
import QrCode from './QrCode'
import Edit from './Edit'
import { client } from '@utils/client'
import moment from 'moment'
const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [modalCreateOpen, setModalCreateOpen] = useState(false)
  const [modalQrCodeOpen, setModalQrCodeOpen] = useState(false)
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [qrCodeData, setQrCodeData] = useState()
  const [defaultValues, setDefaultValues] = useState({})
  const [keyword, setKeyword] = useState()

  const fetch = async ({ page, pageSize, keyword }) => {
    let result = await client
      .get('/special-event', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)

    return result
  }

  const columns = [
    {
      title: t('rewards.specialEvent.column.no'),
      dataIndex: 'no',
      key: 'no',
      width: 50,
    },
    {
      title: t('rewards.specialEvent.column.dateStart'),
      dataIndex: 'start',
      key: 'start',
      width: 50,
      render: function date(date) {
        return moment(date).format('YYYY-MM-DD')
      },
    },
    {
      title: t('rewards.specialEvent.column.timeStart'),
      dataIndex: 'start',
      key: 'start',
      width: 50,
      render: function date(date) {
        return moment(date).format('HH:mm:ss')
      },
    },
    {
      title: t('rewards.specialEvent.column.dateEnd'),
      dataIndex: 'end',
      key: 'end',
      width: 50,
      render: function date(date) {
        return moment(date).format('YYYY-MM-DD')
      },
    },

    {
      title: t('rewards.specialEvent.column.timeEnd'),
      dataIndex: 'end',
      key: 'end',
      width: 50,
      render: function date(date) {
        return moment(date).format('HH:mm:ss')
      },
    },
    {
      title: t('rewards.specialEvent.column.name'),
      dataIndex: 'name',
      key: 'name',
      width: 140,
    },
    {
      title: t('rewards.specialEvent.column.point'),
      dataIndex: 'point',
      key: 'point',
      width: 40,
    },
    {
      title: t('rewards.specialEvent.column.qrCode'),
      // dataIndex: 'qrCode',
      key: 'qrCode',
      width: 80,
      render: function code(rowData) {
        return (
          <a
            onClick={() => {
              setQrCodeData(rowData.id)
              setModalQrCodeOpen(true)
            }}
          >
            {t('rewards.specialEvent.column.qrCodeLabel')}
          </a>
        )
      },
    },

    {
      title: t('rewards.specialEvent.column.status'),
      key: 'status',
      dataIndex: 'status',
      width: 80,
      render: function status(status) {
        let color = ''
        let text = ''
        if (status === 'available') {
          //available
          color = '#5BBD94'
          text = 'ใช้งานได้'
        } else if (status === 'unavailable') {
          color = '#818181'
          text = 'ใช้แล้ว'
        } else if (status === 'expired') {
          color = '#D5462D'
          text = 'หมดอายุแล้ว'
        }

        return <p style={{ color: color, fontWeight: 'bold' }}>{text}</p>
      },
    },

    {
      title: '',
      // dataIndex: 'edit',
      key: 'edit',
      width: 50,
      render: function reswardSpecialEvent(rowData) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setModalEditOpen(true)
                  setDefaultValues(rowData)
                }}
              >
                <Space>{t('rewards.listOperation.edit')}</Space>
              </a>
            ),
          },

          {
            type: 'divider',
          },

          {
            key: '3',
            label: (
              <div>
                <Popconfirm
                  placement="left"
                  title={t('rewards.listOperation.deleteConfirmQuestion')}
                  okText={t('rewards.listOperation.okText')}
                  cancelText={t('rewards.listOperation.cancelText')}
                  onConfirm={() => onDelete(rowData.id)}
                >
                  <a href="#">
                    <Space
                      style={{
                        width: '100%',
                        color: '#56B9C3',
                        justifyContent: 'center',
                      }}
                    >
                      {t('rewards.listOperation.delete')}
                    </Space>
                  </a>
                </Popconfirm>
              </div>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async (id) => {
    try {
      await client.delete(`/special-event/${id}`)
      message.success(t('rewards.listOperation.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('rewards.listOperation.deleteFailed'))
    }
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
  }

  return (
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, keyword }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t('rewards.specialEvent.listScreen.title')}
              shownBack={false}
              extra={[
                <Button
                  type="primary"
                  key="reload"
                  icon=""
                  onClick={() => {
                    setModalCreateOpen(true)
                  }}
                  style={style.btnAddData}
                >
                  {t('rewards.list.addData')}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>

      <Create
        modalCreateOpen={modalCreateOpen}
        setModalCreateOpen={setModalCreateOpen}
      />
      <Edit
        modalEditOpen={modalEditOpen}
        setModalEditOpen={setModalEditOpen}
        defaultValues={defaultValues}
      />

      <QrCode
        qrCodeData={qrCodeData}
        modalQrCodeOpen={modalQrCodeOpen}
        setModalQrCodeOpen={setModalQrCodeOpen}
      />
    </>
  )
}

const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('rewards.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}

export default List
